import isLength from 'validator/lib/isLength'
import isEmail from 'validator/lib/isEmail'
import { isPasswordValid } from './validationUtils'

export const applyValidation = (rules: Array<string>, value: string) => {
  let isError = false
  let message = ''

  for (let i = 0; i < rules.length; i++) {
    // 必須チェック
    if (rules[i] === 'required') {
      if (value === '') {
        isError = true
        message = '必須項目です。入力してください。'
        break
      }
    }

    if (value !== '') {
      // 指定桁数
      if (rules[i].indexOf('max') != -1) {
        const arr = rules[i].split(':')
        const size = Number(arr[1])

        if (isLength(value, { min: 0, max: size }) === false) {
          isError = true
          message = size + '字以内で入力してください。'
          break
        }
      }

      // メールアドレスチェック
      if (rules[i] === 'email') {
        if (isEmail(value) === false) {
          isError = true
          message = 'メールアドレス形式で入力してください。'
          break
        }
      }

      // 半角数字以外の入力エラー
      if (rules[i] === 'number') {
        if (/^[0-9]*$/.test(value) === false) {
          isError = true
          message = '半角数字で入力してください。'
          break
        }
      }

      // 半角英数字記号以外の入力エラー
      if (rules[i] === 'hankakueisu') {
        if (/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value) === false) {
          isError = true
          message = '半角英数字と半角記号で入力してください。'
          break
        }
      }

      // 郵便番号のチェック
      if (rules[i] === 'zip') {
        if (/^[0-9]*$/.test(value) === false || value.length !== 7) {
          isError = true
          message = '郵便番号の形式で入力してください。'
          break
        }
      }

      // ラジオボタン、セレクトボックスなどの指定の値
      if (rules[i] === 'select') {
        if (value === '') {
          isError = true
          message = '選択してください。'
          break
        }
      }

      // 日付チェック
      if (rules[i] === 'date') {
        let error = false
        if (/^\d{4}\/\d{1,2}\/\d{1,2}$/.test(value) === false) {
          error = true
        } else {
          const d: Array<any> = value.split('/')
          const dt = new Date(d[0] - 0, d[1] - 1, d[2] - 0)
          if (
            dt.getFullYear() != d[0] ||
            dt.getMonth() != d[1] - 1 ||
            dt.getDate() != d[2]
          ) {
            error = true
          }
        }

        if (error) {
          isError = true
          message = '正しい日付で入力してください。'
          break
        }
      }

      // カタカナチェック
      if (rules[i] === 'kana') {
        if (/^[ァ-ンヴ・ー一]*$/.test(value) === false) {
          isError = true
          message = 'カタカナで入力してください。'
          break
        }
      }

      // Email不一致チェック
      if (rules[i].indexOf('matchEmail') != -1) {
        const target = rules[i].replace('matchEmail:', '')

        if (value !== target) {
          isError = true
          message = 'メールアドレスが一致しません。'
          break
        }
      }

      // パスワード
      if (rules[i] === 'password') {
        // eslint-disable-next-line
        if (!isPasswordValid(value)) {
          isError = true
          message =
            'パスワードの入力値に誤りがあります。半角英数字記号を8文字以上30文字以内で入力してください。'
          break
        }
      }

      // パスワード不一致チェック
      if (rules[i].indexOf('matchPassword') != -1) {
        const target = rules[i].replace('matchPassword:', '')

        if (value !== target) {
          isError = true
          message = 'パスワードが一致しません。'
          break
        }
      }
    }
  }

  // console.log({ isError: isError, message: message })

  return { isError: isError, message: message }
}
